module.exports = __webpack_public_path__ + "static/honest-health-logo-9dace6f6138187ae06d9907a917a2cae.png";